import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onBeforeUnmount, nextTick} from 'vue'
import { JtTableProps } from '@/components/JtTable/types'
import * as DepAPI from '@/api/ocr'
import {
  Message as ElMessage,
  MessageBox
} from 'element-ui'
import { downloadFile } from '@/utils'
import { OCR } from '@/api/ocr/type'
import { taskStateMap } from './type'
import OcrResult from './components/OcrResult.vue'
import { PageReqSchema } from '@/types/axios/public-json-structure'
import { convertToBrowserTimezone } from '@/utils'
import { StorageDaysModule } from '@/store/modules/storage-days'


export default /*#__PURE__*/_defineComponent({
  __name: 'OcrList',
  setup(__props) {

const jtTableRef = ref()

// 表头
const tableConfig: JtTableProps.ColumnConfig[] = [
  {
    label: '名称',
    prop: 'name',
    isSlot: true
  },
  {
    label: '创建时间',
    prop: 'createDt',
    elColProps: {
      formatter(row: OCR.OCRListRes) {
        if (row.createDt) {
          return convertToBrowserTimezone(row.createDt)
        } else {
          return '-'
        }
      }
    }
  },
  {
    label: '状态',
    prop: 'status',
    isSlot: true
  },
  {
    label: '操作',
    prop: 'handle',
    isSlot: true,
    elColProps: {
      align: 'left',
      width: '120',
    }
  }
]
const tableData = ref<OCR.OCRListRes[]>([])
async function tableApi(page: PageReqSchema) {
  // 清空勾选
  nextTick(() => {
    selectData.value = []
  })
  try {
    let res = await DepAPI.getOcrResultList(page)
    tableData.value = res.data
    loopGetProgress(tableData.value)
    return res
  } catch (error) {
    error
  }
}
let timers: number | undefined
// 轮询查询进度
function loopGetProgress(data:OCR.OCRListRes[]) {
  let idArray: string[] = []
  timers && clearInterval(timers)
  timers = window.setInterval(() => {
    idArray = []
    const filterArray = data.filter((t:OCR.OCRListRes) => t.status != OCR.ETaskState.Done && t.status != OCR.ETaskState.Fail)
    idArray.push(...filterArray.map((t: OCR.OCRListRes) => t.id))
    if (!idArray.length) {
      clearInterval(timers)
      timers = undefined
    } else {
      idArray.forEach(t =>{
        getProgress(t)
      })
      // 更新识别进度及状态
      jtTableRef.value?.updateTableData(tableData.value)
    }
  }, 2000)
}

// 根据ids获取当前页待识别和识别中item的最新状态与进度
async function getProgress (id: string) {
  if (!id.length) return
  const { data } = await DepAPI.getOcrProgressApi(id)
  tableData.value?.forEach((t: OCR.OCRListRes) => {
    if (data.id == t.id) {
      t.progress = Number(data.progress)
      t.status = data.status
    }
  })

}
// 根据状态排序
function sortByState (data: OCR.OCRListRes[]) {
  const order: OCR.ETaskState[] = [
    OCR.ETaskState.Working,
    OCR.ETaskState.Fail,
    OCR.ETaskState.Loading,
    OCR.ETaskState.Done
  ]
  const target: OCR.OCRListRes[] = []
  order.forEach((status) => {
    const sortArray = data.filter(t => t.status === status).sort((a, b) => {
      return handleTimeSort(b.createDt, a.createDt)
    })
    if (sortArray.length) {
      target.push(...sortArray)
    }
  })
  return target
}
function handleTimeSort (t1: string, t2: string) {
  return Number(new Date(t1).getTime()) - Number(new Date(t2).getTime())
}
onBeforeUnmount(() => {
  clearInterval(timers)
})
const checkboxConfig = {
  // 仅完成状态的条目可勾选
  selectable: (row: OCR.OCRListRes) => {
    return row.status === OCR.ETaskState.Done
  }
}

const param = ref('')
//是否打开识别结果
const ocrResult = ref(false)
const ocrResultId = ref('')
const isSave = ref(false)
function handleBack(){
  ocrResult.value = false
  ocrResultId.value = ''
  isSave.value = false
}
// 展示识别详情
function handleShowOcrResult (scope: OCR.OCRListRes) {
  if(scope.status == OCR.ETaskState.Done){
    ocrResult.value = true
    ocrResultId.value = scope.id
  }
}
const ocrResultRef = ref<InstanceType<typeof OcrResult>>()
function handleSaveRes (flag: boolean) {
  isSave.value = flag
}
function goOCRIndex () {
  if (isSave.value) {
    MessageBox.confirm('是否保存更改内容', '提示', {
      distinguishCancelAndClose: true,
      confirmButtonText: '保存',
      cancelButtonText: '不保存',
      type: 'warning'
    }).then(() => {
      ocrResultRef.value?.handleSave()
      handleBack()
    }).catch((action) => {
      if (action === 'cancel') handleBack()
    })
  } else {
    handleBack()
  }
}
function getStateTitle(status: OCR.ETaskState) {
  return taskStateMap[status]
}

const selectData = ref<OCR.OCRListRes[]>([])
function selectChange (data: OCR.OCRListRes[]) {
  selectData.value = data
}

//导出,删除
function handleExportRow(row: OCR.OCRListRes){
  btnLoading.downloadTemplate = true
  DepAPI.downloadOcrApi([row.id])
    .then(downloadFile)
    .catch(err => {
      ElMessage.error('导出失败:' + err.message)
    })
    .finally(() => btnLoading.downloadTemplate = false)
}
// 删除任务
async function handleDelTask(t: OCR.OCRListRes[]){
  MessageBox.confirm('删除后不可恢复，请确认', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    try {
      let ids = t.map(i => i.id)
      DepAPI.delOcrApi(ids).then(()=>{
        ElMessage.success('删除成功!')
        jtTableRef.value.refreshCurrent()
      })
    } catch (error) {
      ElMessage.error('删除失败!')
    }
  }).catch(() => {})
}

function handleMuchExport(){
  btnLoading.downloadTemplate = true
  const ids = selectData.value.map(t => t.id)
  DepAPI.downloadOcrApi(ids)
    .then(downloadFile)
    .catch(err => {
      ElMessage.error('导出失败:' + err.message)
    })
    .finally(() => btnLoading.downloadTemplate = false)
}

const btnLoading = reactive({
  import: false,
  export: false,
  downloadTemplate: false,
})



return { __sfc: true,jtTableRef, tableConfig, tableData, tableApi, timers, loopGetProgress, getProgress, sortByState, handleTimeSort, checkboxConfig, param, ocrResult, ocrResultId, isSave, handleBack, handleShowOcrResult, ocrResultRef, handleSaveRes, goOCRIndex, getStateTitle, selectData, selectChange, handleExportRow, handleDelTask, handleMuchExport, btnLoading, OCR, OcrResult, StorageDaysModule }
}

})